import "./newVehicle.css";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { addbikenum } from "../../../Redux/actions/NumBikeation";
import { Form, Input, Row, Col, Button, message } from "antd/lib";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function NewBikeRegister({ setPopVisible }) {
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onFinish = (data) => {
    setLoading(true);
    const post = {
      phonenumber: data?.phonenumber,
      insurance: "Bike Insurance",
      insurance_type: "new",
    };
    axiosInstance
      .post(`/bike_insurances/new/register`, post)
      .then((res) => {
        if (res.status === 200) {
          const Resdata = res?.data;
          // console.log(Resdata);
          const CombData = {
            ...Resdata,
            phonenumber: post?.phonenumber,
          };
          dispatch(addbikenum(CombData));
          setPopVisible(false);
          setLoading(false);
          history.push("/newVehiclelayout");
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        setLoading(false);
        setPopVisible(false);
        message.error(err.response.data.message);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Form
        layout={formLayout}
        form={form}
        style={{ width: "100%" }}
        className="ant-quote-form col-xl-6 col-lg-6 col-md-6 py-3"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="phonenumber"
              label="Enter Mobile Number"
              rules={[
                {
                  pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                  message: "Invalid Mobile No",
                },
                { required: true, message: "Enter Mobile No" },
              ]}
            >
              <Input maxLength={10} placeholder="Enter Mobile Number"></Input>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item {...buttonItemLayout}>
              <Button
                style={{ width: "100%" }}
                loading={loading}
                type="primary"
                htmlType="submit"
              >
                View Price
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
